var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{staticClass:"el-icon-delete",staticStyle:{"margin-left":"20px","font-size":"15px"},attrs:{"title":"删除"},on:{"click":function($event){return _vm.deleteMdAccessories(_vm.value)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }